export function extractScannedCode(scanData: any) {
  const rawValue = scanData[0].rawValue.trim()
  const serialMatch = rawValue.match(/\$Serial\+([^$\|\r\n]+)/i)
  return serialMatch?.[1]?.trim() ?? rawValue
}

export function extractSoNo(rawValue: string): string | undefined {
  const match = rawValue.match(/\$Batch\+([^$\|\r\n]+)/i)
  return match?.[1]?.trim() || undefined
}
